module.exports = __webpack_public_path__ + "media/images/btn_download_stallions-5988082d2ed87d21536f20924f6960d8.gif";